import React from 'react'
import styled from 'styled-components'

interface Props {
  size?: number
  label: string | React.ReactNode
  active: boolean
  dataTest?: string
  className?: string
  onClick?: () => void
  order?: number
  style?: React.CSSProperties
  hidden?: boolean
}

export const Tab: React.FC<Props> = ({
  size = 14,
  label,
  order,
  style,
  active,
  dataTest,
  className,
  onClick,
  hidden
}) => {
  if (hidden) {
    return null
  }

  if (active) {
    return (
      <StyledActiveTab
        size={size}
        data-test={dataTest}
        className={className}
        onClick={onClick}
        $order={order}
      >
        {label}
        <StyledUnderline />
      </StyledActiveTab>
    )
  }

  return (
    <StyledTab
      $order={order}
      size={size}
      style={style}
      data-test={dataTest}
      className={className}
      onClick={onClick}
    >
      {label}
    </StyledTab>
  )
}

const StyledTab = styled.div<{ size?: number; $order?: number }>`
  cursor: pointer;
  font-weight: 400;
  line-height: 54px;
  padding: 0px 15px;
  white-space: nowrap;
  font-size: ${props => props.size}px;
  order: ${props => props.$order};
`

const StyledUnderline = styled.hr`
  height: 3px;
  border: none;
  background: #1991eb;
  margin: -15px 0px 0px 0px;
`

const StyledActiveTab = styled.div<{ size?: number; $order?: number }>`
  font-weight: 400;
  line-height: 54px;
  padding: 0px 15px;
  white-space: nowrap;
  font-size: ${props => props.size}px;
  order: ${props => props.$order};
`
